
angular.module('bmsApp.crm.document').controller('DocumentIndexCtrl', [
	'$scope',
	'$ngBootbox',
	'notify',
	'DocumentSvc',
	'$window', function (
		$scope,
		$ngBootbox,
		notify,
		DocumentSvc,
		$window) {

		var loadDocuments = function () {
			$scope.loading = true;
			DocumentSvc.index({})
				.then(function (response) {
					$scope.globalDocuments = response.data.global_document_collection;
					$scope.loading = false;
				});
		};

		$scope.removeDocument = function (document) {
			$ngBootbox.confirm('Are you sure you want to remove this document? This can not be undone.')
				.then(function () {
					DocumentSvc.delete(document)
						.then(function (response) {
							loadDocuments();
							notify({
								message: 'Document deleted successfully'
							});
						});
				});
		};

		$scope.$on('DocumentDropzone-queuecomplete', function () {
			loadDocuments();
		});

		$scope.downloadAttachment = function(filename) {
			$window.open('file/download/'+filename, '_blank');
		}

		loadDocuments();

	}]);
